import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import {
    AppBar,
    Avatar,
    Badge,
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    Toolbar,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import LayoutContainer from './LayoutWrapper';
import CloseIcon from '@mui/icons-material/Close';
const Header = () => {
    const { logo, email } = useSelector((state) => state.shop);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const cartItems = useSelector((state) => state.cart.items);
    const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
    const [openCart, setOpenCart] = useState(false);
    const navigate = useNavigate();
    const menuItems = [
        { label: 'Home', to: '/' },
        { label: 'Shop', to: '/shop' },
        { label: 'Cart', to: '/cart' },
        { label: 'Checkout', to: '/checkout' },
    ];

    return (
        <Box sx={{ width: '100%', overflowX: 'hidden' }}>
            {/* Top black bar */}
            <Box sx={{ bgcolor: 'black' }}>
                <LayoutContainer sx={{ px: { md: 10 }, bgcolor: 'black', color: 'white', py: 0.5, display: 'flex', justifyContent: 'space-between', px: { xs: 2, md: 10 } }}>
                    <Typography variant="body2">{email || `support@${window.location.hostname}`}</Typography>
                </LayoutContainer>
            </Box>

            {/* Main Header */}
            <AppBar position="static" elevation={0} sx={{ maxWidth: 1400, bgcolor: 'white', mt: 1, color: 'black', boxShadow: 'none', justifySelf: "center" }}>
                <Toolbar sx={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: { xs: 2, md: 0 } }}>

                    {/* Mobile Menu Icon */}
                    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                        <IconButton onClick={() => setDrawerOpen(true)}>
                            <MenuIcon />
                        </IconButton>
                    </Box>

                    {/* Logo */}
                    <Box component={Link} to="/" sx={{ textDecoration: 'none' }}>
                        {logo ? (
                            <img src={logo} alt="Logo" style={{ width: 120 }} />
                        ) : (
                            <Typography sx={logoStyle}>{window.location.hostname.toUpperCase()}</Typography>
                        )}
                    </Box>

                    {/* Menu - only show on desktop */}
                    <Stack direction="row" spacing={4} sx={{ display: { xs: 'none', md: 'flex' } }}>
                        {menuItems.map((item) => (
                            <Typography key={item.to} component={Link} to={item.to} sx={linkStyle}>
                                {item.label}
                            </Typography>
                        ))}
                    </Stack>

                    {/* Right icons */}
                    <Stack direction="row" spacing={2}>
                        <IconButton><SearchIcon /></IconButton>
                        <IconButton><Badge badgeContent={0} color="error"><FavoriteBorderIcon /></Badge></IconButton>
                        <IconButton onClick={() => setOpenCart(true)}>
                            <Badge badgeContent={totalQuantity} color="error">
                                <ShoppingBagOutlinedIcon />
                            </Badge>
                        </IconButton>

                    </Stack>
                </Toolbar>
            </AppBar>

            {/* Drawer */}
            <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <Box
                    sx={{
                        width: 280,
                        bgcolor: '#f9f9f9',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    role="presentation"
                    onClick={() => setDrawerOpen(false)}
                >
                    {/* Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 2 }}>
                        {logo ? (
                            <Box component="img" src={logo} alt="Logo" sx={{ width: 120, mr: 2 }} />
                        ) : (
                            <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                                {window.location.hostname.charAt(0).toUpperCase()}
                            </Avatar>
                        )}
                        {/* <Typography fontWeight={600} fontSize="1.2rem">
                            {window.location.hostname.toUpperCase()}
                        </Typography> */}
                    </Box>

                    <Divider />

                    {/* Menu Items */}
                    <List sx={{ flexGrow: 1 }}>
                        {menuItems.map((item) => (
                            <ListItem key={item.to} disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to={item.to}
                                    sx={{
                                        py: 1.5,
                                        px: 3,
                                        fontWeight: 500,
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.main',
                                        },
                                    }}
                                >
                                    <ListItemText primary={item.label} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>

                    {/* Optional Footer or Social Icons */}
                    <Box sx={{ p: 2, borderTop: '1px solid #eee', textAlign: 'center' }}>
                        <Typography variant="caption" color="text.secondary">
                            &copy; {new Date().getFullYear()} {window.location.hostname}
                        </Typography>
                    </Box>
                </Box>
            </Drawer>
            <Drawer anchor="right" open={openCart} onClose={() => setOpenCart(false)}>
                <Box sx={{ width: 350, p: 2, position: 'relative' }}>
                    {/* Nút X */}
                    <IconButton
                        onClick={() => setOpenCart(false)}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Tiêu đề */}
                    <Typography variant="h6" fontWeight={700} sx={{ pr: 4 }}>
                        Your Cart
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    {cartItems.length === 0 ? (
                        <Typography>Your cart is empty.</Typography>
                    ) : (
                        <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            {cartItems.map((item, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <Typography fontWeight={600}>{item.product.name}</Typography>
                                    {item.color?.name && <Typography variant="body2">Size: {item.size} – Color: {item.color.name}</Typography>}
                                    <Typography variant="body2">Qty: {item.quantity}</Typography>
                                    <Typography variant="body2" color="crimson">
                                        ${(item.product.price * item.quantity).toFixed(2)}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    )}

                    {/* Total & Actions */}
                    <Divider sx={{ my: 2 }} />
                    <Typography fontWeight={700}>
                        Total:{' '}
                        <span style={{ color: 'crimson' }}>
                            ${cartItems.reduce((sum, item) => sum + item.quantity * item.product.price, 0).toFixed(2)}
                        </span>
                    </Typography>

                    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button
                            variant="outlined"
                            fullWidth
                            onClick={() => {
                                setOpenCart(false);
                                navigate('/cart');
                            }}
                        >
                            View Cart
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => {
                                setOpenCart(false);
                                navigate('/checkout');
                            }}
                        >
                            Checkout
                        </Button>
                    </Box>
                </Box>
            </Drawer>

        </Box >
    );
};

const logoStyle = {
    fontFamily: 'Chakra Petch, sans-serif',
    fontWeight: 600,
    fontSize: '1.5rem',
    letterSpacing: '1px',
    textTransform: 'uppercase',
};

const linkStyle = {
    textDecoration: 'none',
    color: 'inherit',
    fontWeight: 500,
    fontFamily: 'Chakra Petch, sans-serif',
    '&:hover': {
        color: '#007aff',
    },
};

export default Header;
